<template lang="pug">
    section.title-section.container
      lei-popover(
        :text="tooltips.legalName")
        .title-block
          slot
            h2.title {{companyName}}
            div.conformity(v-if="conformityFlag")
              div.conformity-conforming(v-if="conformityFlag === 'CONFORMING'")
                <img src="static/icons/gleif_approved.svg"/> Policy Conforming
              div.conformity-nonconforming(v-if="conformityFlag === 'NON_CONFORMING'")
                <img src="static/icons/gleif_warning.svg"/> Policy Non-Conforming
              div.conformity-not-applicable(v-if="conformityFlag === 'NOT_APPLICABLE'")
                <img src="static/icons/gleif_normal.svg"/> LEI end state - Policy Not Applicable
              lei-popover(:text="getConformityTooltip" :trigger="'click'" :placement="'right'" width="280")
            small(v-if="recordPublishDate").publish-date as of {{ recordPublishDate }}
            p.country {{companyCountry}}
      lei-popover(v-if="showHistoricalSelect" :text="tooltips.currentData")
        .select-block
          el-select.showing-select.lei-select.light.md(value="Showing current data")
            el-option(label="test", value="test")
</template>
<script>
import { mapGetters, } from 'vuex'
import LeiPopover from '../lei-components/LeiPopover'
import { record, } from '../../constants/tooltips/index'
import { dgDashboardURL, } from '@/constants/api'

export default {
  components: {
    LeiPopover,
  },
  props: {
    showHistoricalSelect: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      tooltips: record,
    }
  },
  computed: {
    getConformityTooltip () {
      return `
        <p>The Policy Conformity Flag indicates whether the
          LEI record meets certain Regulatory Oversight Committee (ROC) policies.
        </p>
        <p class="conformity-link">
          <a href="${dgDashboardURL}/leis/${this.lei}?conformity=1" target="_blank">Explore the data</a>
          <a href="https://www.gleif.org/en/lei-data/access-and-use-lei-data/policy-conformity-flag" target="_blank">More details</a>
        </p>
      `
    },

    ...mapGetters('record', [
      'lei',
      'companyName',
      'companyCountry',
      'recordPublishDate',
      'conformityFlag',
    ]),
  },
}
</script>
<style lang="stylus" scoped>
  @import "../../assets/styles/variables.styl"

  .conformity
    margin 10px 0
    display flex
    font-size 1.8rem

    img
      width 26px
      vertical-align bottom
      padding-bottom 5px

  .conformity-conforming
    color $turquoise-color
    white-space nowrap

  .conformity-nonconforming
    color $warning-color
    white-space nowrap

  .conformity-not-applicable
    color $primary-color-light-5
    white-space nowrap

  .title-section
    justify-content space-between
    align-items left
    .publish-date
      font-style italic
    .title-block
      flex 1
      margin-right 10px
      line-height 1.25
      overflow hidden
      text-overflow ellipsis
      .title
        color $default-color-bold
        font-weight 600
      .country
        margin-top 20px
        color $default-color-bold
        display none
      .lei-popover-box
        display inline

  @media (max-width: $laptop)

    .conformity
      font-size 1.2rem

    .conformity-conforming,
    .conformity-nonconforming,
    .conformity-not-applicable
      img
        width 20px
        padding-bottom 3px

    .title-section
      .title-block
        margin-right 0
        .title
          font-size 1.2rem
        .country
          font-size 90%
          display block
      .select-block
          display none
</style>



// WEBPACK FOOTER //
// src/components/record-details/TitleSection.vue